import { Component, Input } from '@angular/core';

import { PrimaryDropdownComponent } from '../primary-dropdown/primary-dropdown.component';

@Component({
  selector: 'kh-breadcrumbs-dropdown',
  styleUrls: ['./breadcrumbs-dropdown.component.less'],
  templateUrl: './breadcrumbs-dropdown.component.html',
  standalone: false
})
export class BreadcrumbsDropdownComponent<TItem> extends PrimaryDropdownComponent<TItem> {
  @Input() public arrowColor = 'arrow-blue';
  @Input() public isActive = false;
}
